import React from "react"
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import Table from 'react-bootstrap/Table'
import FeatherIcon from 'feather-icons-react';
import PropTypes from "prop-types"
import axios from "axios";

class FormationModal extends React.Component {
  state = {
    show: this.props.show
  }

  saveFormation = (event) => {
    const formation_type = event.currentTarget.value;
    const formation_id   = event.currentTarget.dataset.id;
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    const saveFormationRequest = async () => {
      const response = await axios.post(
          `/formations/${formation_id}`,
          { formation_type: formation_type },
          { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
        )
    }
    saveFormationRequest();
  }

  confirmFormations = (event) => {
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    const confirmFormationRequest = async () => {
      const response = await axios.post(
          `/formations/confirm`,
          {},
          { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
        )
      this.setState({
        show: false
      });
      window.location.href = "/dashboard?tour=welcome";
    }
    confirmFormationRequest();
  }

  render () {
    return (
      <React.Fragment>
        <Modal 
          size="lg"
          show={this.state.show}
          backdrop="static"
          centered>
          <Modal.Header>
            <Modal.Title>Tell us about {this.props.application}'s Architecture</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container>
              <p>Help us understand {this.props.application}'s Processes.  We made a few guesses about the type of processes running in each dyno. Please check our work.</p>
              <Table striped bordered hover>
                <thead>
                <tr>
                  <th>
                    <div className="form-tooltip">
                      <span className="fw-bolder">Process Name <FeatherIcon icon="help-circle" className="mt-1"/></span>
                      <span className="form-tooltiptext">What is this process called?</span>
                    </div>
                  </th>
                  <th>
                    <div className="form-tooltip">
                      <span className="fw-bolder">Process Command<FeatherIcon icon="help-circle" className="mt-1"/></span>
                      <span className="form-tooltiptext">What command is this process running?</span>
                    </div>
                  </th>
                  <th>
                    <div className="form-tooltip">
                      <span className="fw-bolder">Process Type<FeatherIcon icon="help-circle" className="mt-1"/></span>
                      <span className="form-tooltiptext">What type of process is this?</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.formations.map((formation, i) => (
                <tr key={i}>
                  <td><p>{formation.name}</p></td>
                  <td><p>{formation.command}</p></td>
                  <td>
                    <label className="formation-type-label">
                      <select required={true} className="form-control formation-type" data-field="dyno_type" data-id={formation.id} defaultValue={formation.formation_type} onChange={this.saveFormation}>
                        { this.props.formation_types.map((formation_type, index) => (
                          <option value={formation_type} key={index}>{formation_type.charAt(0).toUpperCase() + formation_type.substring(1)}</option>
                        ))}
                      </select>
                    </label>
                  </td>
                </tr>
                ))}
                </tbody>
              </Table>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-success btn-lg" type="button" data-toggle="tooltip" data-placement="top" title="Save Process Types" onClick={this.confirmFormations}>
               <FeatherIcon icon="save"/><span style={{"marginLeft": "5px" }}>Looks Good to Me!</span>
            </button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

FormationModal.propTypes = {
  application: PropTypes.string,
  formations: PropTypes.array,
  formation_types: PropTypes.array,
  show: PropTypes.bool
};

export default FormationModal
